import { Flex } from 'theme-ui';
import { Shift } from '@velove/types';

import Button, { ButtonProps } from '../Button';

import ShiftCard, { ShiftCardProps } from './ShiftCard';

export interface UpcomingShiftCardProps extends Omit<ShiftCardProps, 'actions' | 'status' | 'availableShift'> {
  infoButton: {
    as: ButtonProps['as'];
    label: string;
  };
  shift: Shift;
}

const UpcomingShiftCard: React.FC<UpcomingShiftCardProps> = ({ infoButton, shift, ...props }) => (
  <ShiftCard
    {...props}
    actions={
      <Flex
        sx={{
          justifyContent: 'flex-end',
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'veloGrey3',
          py: 's'
        }}
      >
        <Button
          variant="textDarkBlue"
          as={infoButton.as}
          trailingIcon="ArrowRight"
          trailingIconProps={{ circular: true }}
        >
          {infoButton.label}
        </Button>
      </Flex>
    }
    status="UPCOMING"
    availableShift={shift.availableShift}
  />
);

export default UpcomingShiftCard;
